<template>
  <GbwapsLayout title="GB WhatsApp Anti-Ban Guide" :intro="pageIntro" :breadcrumb="breadcrumb">
    <div class="anti-ban-page">
      <div class="warning-box anti-ban-risk-warning">
        <strong>Risk warning:</strong>
        Using GB WhatsApp carries ban risk. WhatsApp may restrict unofficial clients—use a secondary number first if you
        are unsure.
      </div>

      <PageChecklist title="Anti-ban safety checklist" :items="checklist" class="mb-24" />

      <section
        v-for="section in sections"
        :id="section.id"
        :key="section.id"
        class="page-section site-section"
      >
        <h2>{{ section.h2 }}</h2>
        <ContentBlocks :blocks="section.blocks" />

        <div v-if="section.layout === 'risk-tips'" class="risk-tips-grid">
          <article
            v-for="tip in riskTips"
            :key="tip.title"
            class="risk-tip-card card"
            :class="'risk-tip-card--' + tip.level"
          >
            <h3>{{ tip.title }}</h3>
            <p>{{ tip.text }}</p>
            <span class="risk-tip-level">{{ tip.level === 'high' ? 'High risk' : 'Medium risk' }}</span>
          </article>
        </div>

        <PageChecklist v-if="section.layout === 'checklist'" title="Settings checklist" :items="checklist" />
      </section>
    </div>
  </GbwapsLayout>
</template>

<script>
import '@/css/gbwaps/pages.css';
import GbwapsLayout from '@/layouts/GbwapsLayout.vue';
import ContentBlocks from '@/components/gbwaps/ContentBlocks.vue';
import PageChecklist from '@/components/gbwaps/PageChecklist.vue';
import { ANTI_BAN_CHECKLIST, ANTI_BAN_SECTIONS, RISK_TIPS } from '@/data/anti-ban-content';

export default {
  name: 'AntiBanPage',
  components: { GbwapsLayout, ContentBlocks, PageChecklist },
  data() {
    return {
      pageIntro:
        'Reduce GB WhatsApp ban risk with updated APKs, calm usage habits, and settings that avoid spam-like patterns.',
      breadcrumb: [{ name: 'Home', to: '/' }, { name: 'Anti-Ban' }],
      checklist: ANTI_BAN_CHECKLIST,
      riskTips: RISK_TIPS,
      sections: ANTI_BAN_SECTIONS,
    };
  },
};
</script>
